/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2TeamSide } from './MatchOperationV2TeamSide';
import {
    MatchOperationV2TeamSideFromJSON,
    MatchOperationV2TeamSideFromJSONTyped,
    MatchOperationV2TeamSideToJSON,
    MatchOperationV2TeamSideToJSONTyped,
} from './MatchOperationV2TeamSide';

/**
 * 
 * @export
 * @interface PublicMatchOperationV2ActiveSuspension
 */
export interface PublicMatchOperationV2ActiveSuspension {
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2ActiveSuspension
     */
    sourceEventId: string;
    /**
     * 
     * @type {MatchOperationV2TeamSide}
     * @memberof PublicMatchOperationV2ActiveSuspension
     */
    teamSide: MatchOperationV2TeamSide;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2ActiveSuspension
     */
    participantId: string;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2ActiveSuspension
     */
    startedAtEffectiveElapsedMs: number;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2ActiveSuspension
     */
    durationMs: number;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2ActiveSuspension
     */
    expiresAtEffectiveElapsedMs: number;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2ActiveSuspension
     */
    status: PublicMatchOperationV2ActiveSuspensionStatus;
}

/**
* @export
* @enum {string}
*/
export enum PublicMatchOperationV2ActiveSuspensionStatus {
    Active = 'ACTIVE'
}


/**
 * Check if a given object implements the PublicMatchOperationV2ActiveSuspension interface.
 */
export function instanceOfPublicMatchOperationV2ActiveSuspension(value: object): value is PublicMatchOperationV2ActiveSuspension {
    if (!('sourceEventId' in value) || value['sourceEventId'] === undefined) return false;
    if (!('teamSide' in value) || value['teamSide'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('startedAtEffectiveElapsedMs' in value) || value['startedAtEffectiveElapsedMs'] === undefined) return false;
    if (!('durationMs' in value) || value['durationMs'] === undefined) return false;
    if (!('expiresAtEffectiveElapsedMs' in value) || value['expiresAtEffectiveElapsedMs'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2ActiveSuspensionFromJSON(json: any): PublicMatchOperationV2ActiveSuspension {
    return PublicMatchOperationV2ActiveSuspensionFromJSONTyped(json, false);
}

export function PublicMatchOperationV2ActiveSuspensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2ActiveSuspension {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceEventId': json['sourceEventId'],
        'teamSide': MatchOperationV2TeamSideFromJSON(json['teamSide']),
        'participantId': json['participantId'],
        'startedAtEffectiveElapsedMs': json['startedAtEffectiveElapsedMs'],
        'durationMs': json['durationMs'],
        'expiresAtEffectiveElapsedMs': json['expiresAtEffectiveElapsedMs'],
        'status': json['status'],
    };
}

export function PublicMatchOperationV2ActiveSuspensionToJSON(json: any): PublicMatchOperationV2ActiveSuspension {
    return PublicMatchOperationV2ActiveSuspensionToJSONTyped(json, false);
}

export function PublicMatchOperationV2ActiveSuspensionToJSONTyped(value?: PublicMatchOperationV2ActiveSuspension | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceEventId': value['sourceEventId'],
        'teamSide': MatchOperationV2TeamSideToJSON(value['teamSide']),
        'participantId': value['participantId'],
        'startedAtEffectiveElapsedMs': value['startedAtEffectiveElapsedMs'],
        'durationMs': value['durationMs'],
        'expiresAtEffectiveElapsedMs': value['expiresAtEffectiveElapsedMs'],
        'status': value['status'],
    };
}

